import { autoinject } from "aurelia-dependency-injection";
import { MepShorePowerActualEmissionsItem, MepShorePowerActualEmissionsRequest, MepShorePowerForecastEmissionsItem } from "../../../../../../../../models/mep/mep-scenario-planning.models";
import { MepScenarioPlanningSerivce } from "../../../../../../../../services/mep/mep-scenario-planning.service";
import { computedFrom } from "aurelia-binding";
import { useView } from "aurelia-framework";

@autoinject
@useView('views/pages/modules/mep/tabs/mep-scenario-planning/partials/mep-scenario-planning-shore-power/mep-scenario-planning-shore-power.html')
export class MepScenarioPlanningShorePower {

    public subscription: any;
    public baselineYear: number;
    public forecastYear: number;
    public totalForecastAlongsideEmissions: number;
    public totalForecastEmissionChange: number;
    public forecastPercentageChange: number;
    public forecastPercentageChangeDecimals: string;
    public forecastBarPercentage: number;
    public items: MepShorePowerActualEmissionsItem[] = [];
    public forecastItems: MepShorePowerForecastEmissionsItem[] = [];

    private totalEmissionsQtyTonnes: number;

    constructor(private mepScenarioPlanningSerivce: MepScenarioPlanningSerivce) {
    }

    public loadData(request: MepShorePowerActualEmissionsRequest, forecastYear: number): Promise<string> {
        if(request) {
            this.baselineYear = request.baselineYear;
        }
        
        return new Promise<string>((resolve, reject) => {
            this.forecastYear = forecastYear;
            if (request) {
                this.mepScenarioPlanningSerivce.getMepShorePowerActualEmissionsByPoi(request).then(response => {
                    this.items = response.items;
                    this.totalEmissionsQtyTonnes = response.totalEmissionsQtyTonnes;

                    this.forecastItems = [];
                    this.items.forEach(item => {
                        this.forecastItems.push(new MepShorePowerForecastEmissionsItem(item));
                    });

                    resolve(null);
                }).catch(() => {
                    reject(`MEP scenario planning shore power actual emissions by point of interest - Error retrieving the data!`);
                });
            }
        });
    }

    @computedFrom("items")
    get totalBaselineAlongsideEmissions() {
        if(this.items.length > 0) {
            return this.items.reduce((total, number) => total + number.emissionAlongsideTonnes, 0);
        }
    }

    @computedFrom("items")
    get totalBaselineAlongsideEmissionsPercentage() {
        if(this.items.length > 0) {
            return this.items.reduce((total, number) => total + number.emissionAlongsideTonnes, 0) * 100 / this.totalEmissionsQtyTonnes;
        }
    }

    @computedFrom("forecastItems", "totalBaselineAlongsideEmissions", "totalEmissionsQtyTonnes", "totalForecastAlongsideEmissions")
    get totalForecastAlongsideEmissionsPercentage() {
        if(this.items.length > 0) {
            return this.totalForecastAlongsideEmissions * 100 / (this.totalEmissionsQtyTonnes - this.totalBaselineAlongsideEmissions + this.totalForecastAlongsideEmissions);
        }
    }

    @computedFrom("forecastItems")
    get getTotalForecastAlongsideEmissions() {
        if(this.forecastItems.length > 0) {
            this.totalForecastAlongsideEmissions = this.forecastItems.reduce((total, number) => total + number.emissionAlongsideTonnes, 0);

            //Calculate diff tonnes from baseline to forecast
            this.totalForecastEmissionChange = this.totalBaselineAlongsideEmissions - this.totalForecastAlongsideEmissions;

            return this.totalForecastAlongsideEmissions;
        }
    }

    @computedFrom("forecastItems")
    get getForecastBarPercentage() {
        if(this.items.length > 0 && this.forecastItems.length > 0 && this.totalBaselineAlongsideEmissions >= this.getTotalForecastAlongsideEmissions) {
            this.forecastBarPercentage = (this.getTotalForecastAlongsideEmissions / this.totalBaselineAlongsideEmissions) * 100;
            
            //Calculate diff percentage from baseline to forecast
            this.forecastPercentageChange = ((100 - this.forecastBarPercentage) / 100) * 100;
            this.forecastPercentageChangeDecimals = this.forecastPercentageChange.toString().substring(this.forecastPercentageChange.toString().indexOf('.')+1, this.forecastPercentageChange.toString().indexOf('.')+3);

            return this.forecastBarPercentage;
        }
    }

    calculateForecastBarPercentage() {
        this.forecastBarPercentage = this.getForecastBarPercentage;
    }
}